export const FOLDER = 'FOLDER'
export const SEARCH = 'SEARCH'
export const DRAFTS = 'DRAFTS'
